<template>
  <el-row class="rodent-control">
    <el-col :span="16">
      <el-radio-group v-model="type" @change="typeChange">
        <!-- <el-radio-button label="day">今日</el-radio-button>
        <el-radio-button label="week">本周</el-radio-button> -->
        <el-radio-button label="month">本月</el-radio-button>
        <el-radio-button label="year">全年</el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-model="range"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:260px;margin-left:16px;"
        @change="dateChange"
      >
      </el-date-picker>

      <el-checkbox
        :value="filted"
        @input="filtedChange"
        style="margin-left:1rem;display:inline-block;"
      >
        过滤 [重量: 0]
      </el-checkbox>
    </el-col>
    <el-col :span="8" class="text-right">
      <!-- <el-radio-group
        v-model="showType"
        @change="showTypeChange"
      >
        <el-radio-button label="preview">
          图表
        </el-radio-button>
        <el-radio-button label="data">
          数据视图
        </el-radio-button>
      </el-radio-group> -->

      <el-button
        type="text"
        style="margin-left:1rem;display:inline-block;"
        @click="exportExcel"
      >
        导出Excel
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    filted: Boolean
  },
  data() {
    return {
      showType: 'preview',
      type: 'month',
      range: [],
      date: []
    }
  },
  methods: {
    typeChange(type) {
      this.range = []
      let date = moment()
      this.$emit(
        'date-change',
        date.startOf(type).format('YYYY-MM-DD HH:mm:ss'),
        moment().format('YYYY-MM-DD 23:59:59'),
        type === 'day' || type === 'week' ? 'day' : 'month'
      )
    },
    dateChange([begin, end]) {
      this.type = ''
      this.$emit(
        'date-change',
        moment(begin).format('YYYY-MM-DD HH:mm:ss'),
        moment(end).format('YYYY-MM-DD 23:59:59'),
        'month'
      )
    },
    showTypeChange(tab) {
      this.$emit('type-change', tab)
    },
    exportExcel() {
      this.$emit('export')
    },
    filtedChange() {
      this.$emit('filted-change')
    }
  }
}
</script>

<style lang="css" scoped>
.rodent-control {
  padding: 18px 20px;
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
}
.rodent-control {
  margin-bottom: 0 !important;
}
</style>
